import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useContext, useMemo } from "react";
import { useTextDomainContext } from "@/app/providers";

interface MenuItemDocumentProps<TRow extends object = Record<string, unknown>> {
  row?: TRow;
  menuFor?: string;
  handleClose: () => void;
  menuClick: (_action: string, _row?: TRow) => void;
  showItems?: Record<string, boolean | undefined>;
}

export const MenuItemDocument = <TRow extends object = Record<string, unknown>>(
  props: MenuItemDocumentProps<TRow>,
): React.ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  //#region useMemo

  const menuFor = useMemo(() => {
    return props.menuFor ?? "";
  }, [props.menuFor]);

  // console.log(props.row);
  // console.log(props.showItems);

  // props
  // row
  // menuFor

  //#endregion useMemo

  // const handleRedirect = () => {
  //   // Example redirect
  //   // window.location.href = `/details/${row.id}`;
  // };

  // const handleOpenModal = () => {
  //   // Trigger modal logic here
  //   // console.log("Open modal for", row);
  //   handleClose();
  // };

  //#region Handlers

  const handleClose = () => {
    props.handleClose();
  };

  const handleViewAction = () => {
    props.menuClick(`${menuFor}-view`, props.row);
    handleClose();
  };

  const handleEditAction = () => {
    props.menuClick(`${menuFor}-edit`, props.row);
    handleClose();
  };

  const handleDownloadAction = () => {
    props.menuClick(`${menuFor}-download`, props.row);
    handleClose();
  };

  const handleDeleteAction = () => {
    props.menuClick(`${menuFor}-delete`, props.row);
    handleClose();
  };

  //#endregion Handlers

  return (
    <>
      {props?.showItems?.showView && (
        <MenuItem onClick={handleViewAction}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("View")} />
        </MenuItem>
      )}

      {props?.showItems?.showEdit && (
        <MenuItem onClick={handleEditAction}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Edit")} />
        </MenuItem>
      )}

      {props?.showItems?.showDownload && (
        <MenuItem onClick={handleDownloadAction}>
          <ListItemIcon>
            <DownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Download")} />
        </MenuItem>
      )}

      {props?.showItems?.showDelete && (
        <MenuItem onClick={handleDeleteAction}>
          <ListItemIcon>
            <DeleteIcon color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={gettext("Delete")}
            slotProps={{
              primary: {
                color: "error",
              },
            }}
          />
        </MenuItem>
      )}
    </>
  );
};
